export const partiesKeywords = [
    'buyer' , 
    'seller' , 
    'purchaser',
    'vendors', 
    'landlord' , 
    'tenant',
    'agent' //co-broke
];

export const monetaryKeywords = [
    'price', 
    'amount',
    'amt',
    'commission',
    'comm',
    'money' , 
    'fee',
    'gst',
    'gross',
    'percent',
    'Percent',
    'pct', //percent,
    'monthlyrental', //exact fieldname to lowercase
    'securitydeposit', //exact fieldname to lowercase
    'termsoflease', //exact fieldname to lowercase
    'salesPrice',
    'billto'
];


export const salesPerson = "salesPerson";
export const paymentModeField = "paymentMode";
export const agentName = "agentName";
export const associateName = "Associate";
export const submissionDate = "dateOfSubmission";
export const optionDate = "optionDate";
export const gst = "GST";
export const monthlyRental = "monthlyRental";
export const termsOfLeaseMonthsField = "termsOfLeaseMonths";
export const commencementDateField = "commencementDate";
export const expiryDateField = "expiryDate";
export const amountForSales = "amountForSales";
export const nettCommission = "nettCommission";
export const billToField = "billTo";

export const mutualAgreement = "mutualagreement"

export const cobroke = {
    commissionAmount: "cobrokeCommissionAmount",
    commissionRate: "cobrokeCommissionRate",
    commissionType: "cobrokeCommissionType"
}

export const agent = {
    commissionAmount: "commissionAmount",
    commissionRate: "commissionRate",
    commissionType: "commissionType"
}

export const buyer = {
    commissionAmount: "buyerCommissionAmount",
    commissionRate: "buyerCommissionRate",
    commissionType: "buyerCommissionType"
}

export const tenant = {
    commissionAmount: "tenantCommissionAmount",
    commissionRate: "tenantCommissionRate",
    commissionType: "tenantCommissionType"
}

export const landlord = {
    commissionAmount: "landlordCommissionAmount",
    commissionRate: "landlordCommissionRate",
    commissionType: "landlordCommissionType"
}